// extracted by mini-css-extract-plugin
export default {"wrapper":"Reviews_wrapper__3Aj1v","skeleton":"Reviews_skeleton__WENxF","image":"Reviews_image__4MsW3","scale":"Reviews_scale__ftClK"};